export default __webpack_public_path__ + "static/media/definix-white-logo.01d23eca.png";